import React from 'react'
import "./heroImg.css"
import HeroImage from "../assets/hero-back.jpg"
import { Link } from 'react-router-dom'
import { Typewriter } from 'react-simple-typewriter'

export default function HeroImg() {
    return (
        <>
            <div className="hero">
                <div className="mask">
                    <img src={HeroImage} className="hero-img" alt="hero Image" />
                </div>
                <div className="content">
                    <div className="left">
                        <p>
                            <a href="https://m.facebook.com/profile.php?id=100011556826825&eav=AfY2o7yZGFGqZe6DRY6Ok5U02O67KcZCkKkkK7zX9IUcclMq7OXri8bdPIPyhyDMWuk&paipv=0" target="_blank"> <i className="fa-brands fa-facebook"></i> </a>
                            <a href="https://instagram.com/hammad_khan044" target="_blank"> <i className="fa-brands fa-instagram"></i> </a>
                            <a href="https://twitter.com/hk7356231" target="_blank"> <i className="fa-brands fa-twitter"></i> </a>
                        </p>
                        <h4>Hi, I'm Muhammad Hammad Khan</h4>
                        <h1>A <span style={{ color: 'orange' }}>
                            <Typewriter
                                words={['MERN Stack Developer', 'Graphic Designer', 'Freelancer', 'Full Stack Developer']}
                                loop="infinit"
                                cursor
                                cursorStyle='|'
                                typeSpeed={70}
                                deleteSpeed={50}
                                delaySpeed={1000}
                            />
                        </span></h1>
                        <div className="btns">
                            <a href='Resume.pdf' download="Resume.pdf" className="btn">Get_Resume</a>
                            <Link to="/contact" className="btn-light">Contact_Us</Link>
                        </div>
                    </div>
                    <div className="right">

                    </div>
                </div>
            </div>
        </>
    )
}
